<ng-container *ngIf="{ canAddNewTask: canAddNewTask$ | async | notNull } as data">
  <ng-container *ngFor="let item of tasksAndGroups; trackBy: trackControl">
    <ng-container *ngIf="!getTaskGroupForm(item).value.tasks; else taskGroup">
      <tr data-test="FwzNZmDV">
        <td data-test="kkJq_5ZF">
          <div data-test="502KozLM" class="d-flex">
            <div data-test="neF2XwQM" class="items-table__icon">
              <button
                data-test="GPYttmF5"
                type="button"
                (click)="removeTask(item.value)"
                class="button button_red-outline button_square button_square-sm button_rounded-circle"
              >
                <i data-test="yj1R1LC8" class="material-icons md-14">close</i>
              </button>
            </div>
            <div data-test="EEHcxFtz" class="position-relative">
              <div data-test="rmQqfqXT">
                <b data-test="0vgMFrdJ">
                  {{ getTaskForm(item).value.originalTask?.name }}
                </b>
              </div>
            </div>
          </div>
        </td>
        <td data-test="ORVQudI4">
          <div data-test="bRDnMzRe">
            <textarea
              data-test="zijHmuWg"
              (keyup.enter)="saveTask($any(item))"
              [ngrxFormControlState]="getTaskForm(item).controls.description"
              class="input input_sm text-light project-textarea"
              rows="2"
              mdScrollToTop
            ></textarea>
          </div>
        </td>
        <td
          data-test="Qw-iejtd"
          class="text-center"
          [hidden]="currentTab === Tabs.NonBillable"
        >
          <label data-test="FMSRra4N" class="checkbox">
            <input
              data-test="rs9gmGwu"
              [ngrxFormControlState]="item.controls.billable"
              *ngIf="teamTaskForm.value.billingMethod !== BudgetTypes.FEES_PER_TASK"
              type="checkbox"
              checked
            />
            <span data-test="MWpvClwO" class="checkbox__marker">
              <span data-test="NBsLPo02" class="checkbox__marker-icon">
                <svg
                  data-test="U9lQGGYo"
                  class="icon__icon-check"
                  width="9.07px"
                  height="6.95px"
                >
                  <use xlink:href="#icon-check"></use>
                </svg>
              </span>
            </span>
          </label>
        </td>
        <td data-test="mpgS_Oap" class="text-center" [hidden]="hideBudgetHours">
          <input
            data-test="4KWz5Ls9"
            [ngrxFormControlState]="item.controls.budgetHours"
            class="input input_sm w-auto text-center"
            mask="0*.00"
            placeholder="0.00"
            [ngrxValueConverter]="numberConverter"
            [dropSpecialCharacters]="false"
            type="text"
            [size]="4"
          />
        </td>
        <td
          data-test="EtMwG4JK"
          class="text-center text-nowrap"
          *ngIf="
            billingRatePerHour(
              to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
            )
          "
          [class.error]="item.controls.billingRatePerHour.isInvalid"
        >
          <div data-test="AgAnLNki" class="field-item field-item_offset">
            <div data-test="6e7kQdsd" class="field-item__prepend" mdCurrency></div>
            <input
              data-test="65ZDeAv4"
              [ngrxFormControlState]="item.controls.billingRatePerHour"
              [ngrxValueConverter]="numberConverter"
              [mdNumberInput]
              (blur)="onBillableRateChange(item)"
              class="input input_sm text-center"
              placeholder="0.00"
              style="width: 45px"
            />
            <div
              data-test="xHZK4klh"
              *ngIf="item.isInvalid && !item.value.billingRatePerHour"
              class="field-item__append field-item__append_warning"
            >
              <span
                data-test="mY_fr3qI"
                class="icon icon_warning icon_16"
                [mdTooltip]="'Are you sure you want this rate to be blank?'"
              >
                <svg
                  data-test="58c7illb"
                  id="icon-warn"
                  viewBox="0 0 24 24"
                  width="100%"
                  height="100%"
                >
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
                </svg>
              </span>
            </div>
          </div>
        </td>
        <td
          data-test="bPaU0mc-"
          class="text-center"
          *ngIf="showBudgetFee(to(teamTaskForm.controls.budget.value, 'BudgetTypes'))"
        >
          <span data-test="qUuPYgel" class="text-light mr-2" mdCurrency></span>
          <input
            data-test="MOloKXGZ"
            [ngrxFormControlState]="item.controls.budgetFee"
            [ngrxValueConverter]="numberConverter"
            class="input input_sm w-auto text-center"
            mask="0*.00"
            placeholder="0.00"
            [dropSpecialCharacters]="false"
            type="text"
            [size]="4"
          />
        </td>
        <td
          data-test="WitkK20u"
          class="text-right text-nowrap"
          *ngIf="
            billingRatePerHour(
              to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
            ) && !hideBudgetHours
          "
        >
          <span data-test="xJhrKVu_" class="d-inline-block">
            <span data-test="FqY98XI2" mdCurrency></span>
            {{ item.value.budgetHours * item.value.billingRatePerHour | companyCurrency }}
          </span>
        </td>
      </tr>
      <tr data-test="M3Pwsc_w" class="items-table__spacer"></tr>
    </ng-container>
    <ng-template #taskGroup>
      <tr
        data-test="fUGGQ5Pz"
        class="row-type"
        [class.active]="!!expandedTaskGroupsEntities[item.value.uuid.toString()]"
      >
        <td data-test="TGS77-W4">
          <div data-test="IHKudg_g" class="d-flex">
            <button
              data-test="01YCFcJs"
              class="items-table__toggle items-table__icon"
              (click)="toggleTaskGroup(getTaskGroupForm(item).value)"
            >
              <div data-test="6rkUdCSC" class="badge badge_gray">
                <i data-test="vLr1LMf4" class="material-icons md-14">
                  keyboard_arrow_right
                </i>
              </div>
            </button>
            <div data-test="uio770lX" class="items-table__icon">
              <button
                data-test="tz8-JyW2"
                type="button"
                (click)="removeTaskGroup(item.value)"
                class="button button_red-outline button_square button_square-sm button_rounded-circle"
              >
                <i data-test="hXxhZBKv" class="material-icons md-14">close</i>
              </button>
            </div>
            <div data-test="VtDFpvsX" class="position-relative">
              <div data-test="4JSjz0A4">
                <b data-test="sh59eDPA">
                  {{
                    getTaskGroupForm(item).controls.originalTaskGroup.controls.name.value
                  }}
                </b>
              </div>
            </div>
          </div>
        </td>
        <td data-test="TN_gWb5l">
          <div data-test="yGUdLWHn">
            <textarea
              data-test="8KY_zezK"
              (keyup.enter)="saveTaskGroup(getTaskGroupForm(item))"
              [ngrxFormControlState]="item.controls.description"
              class="input input_sm text-light project-textarea"
              rows="2"
              mdScrollToTop
            ></textarea>
          </div>
        </td>
        <td
          data-test="FX3Xf-GK"
          class="text-center"
          [hidden]="currentTab === Tabs.NonBillable"
        >
          <ui-kit-checkbox
            data-test="FQ2sBfgQ"
            (click)="$event.stopPropagation()"
            [showLabel]="false"
          >
            <input
              data-test="XDuiqgVf"
              type="checkbox"
              (input)="toggleTaskGroupBillable(item.value.uuid)"
              [checked]="item.value.billable"
              [indeterminate]="
                taskGroupBillableIndeterminate(getTaskGroupForm(item).value)
              "
            />
          </ui-kit-checkbox>
        </td>
        <td data-test="Yg2SNcOM" class="text-center" [hidden]="hideBudgetHours">
          <input
            data-test="VQf0X5HY"
            [ngrxFormControlState]="item.controls.budgetHours"
            class="input input_sm w-auto text-center"
            mask="0*.00"
            placeholder="0.00"
            [ngrxValueConverter]="numberConverter"
            [dropSpecialCharacters]="false"
            type="text"
            [size]="4"
            (input)="onSetGroupHours(getTaskGroupForm(item).value)"
          />
        </td>
        <td
          data-test="DHQntiuX"
          class="text-center"
          *ngIf="
            billingRatePerHour(
              to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
            ) && !hideBudgetHours
          "
        ></td>
        <td
          data-test="bDbf6UOQ"
          class="text-center"
          *ngIf="showBudgetFee(to(teamTaskForm.controls.budget.value, 'BudgetTypes'))"
        >
          <span data-test="fo7lxB5p" class="text-light mr-2" mdCurrency></span>
          <input
            data-test="ZDY03aRa"
            [ngrxFormControlState]="item.controls.budgetFee"
            [ngrxValueConverter]="numberConverter"
            class="input input_sm w-auto text-center"
            mask="0*.00"
            placeholder="0.00"
            [dropSpecialCharacters]="false"
            type="text"
            [size]="4"
          />
        </td>
        <td
          data-test="ByccYdGg"
          class="text-right"
          *ngIf="
            billingRatePerHour(
              to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
            )
          "
        >
          <span data-test="hZfcBOVQ" mdCurrency></span>
          {{ getTaskGroupTotalAmount(item) | companyCurrency }}
        </td>
      </tr>
      <ng-container *ngIf="!!expandedTaskGroupsEntities[item.value.uuid.toString()]">
        <tr
          data-test="EjXPpu0u"
          class="row-bg row-type"
          *ngFor="
            let groupTask of getTaskGroupForm(item).controls.tasks.controls;
            trackBy: trackControl
          "
        >
          <td data-test="cdKj_LGk">
            <div data-test="N1VDUWFw" class="d-flex">
              <span data-test="W1GADSyf" class="items-table__icon">
                <svg
                  data-test="KZ8hHrgm"
                  class="icon__icon-path"
                  width="8.75px"
                  height="11.04px"
                >
                  <use xlink:href="#icon-path"></use>
                </svg>
              </span>
              <div data-test="DMa_fyFS" class="items-table__icon">
                <button
                  data-test="lY0cyalI"
                  type="button"
                  (click)="removeGroupTask(groupTask.value.uuid, item.value.uuid)"
                  class="button button_red-outline button_square button_square-sm button_rounded-circle"
                >
                  <i data-test="PQpWf8Cj" class="material-icons md-14">close</i>
                </button>
              </div>
              <div data-test="rdJf6mWO" class="position-relative">
                <div data-test="NhNJ4-L5">
                  <b data-test="3I1riDWc">
                    {{
                      getTaskForm(groupTask).controls.originalTask.controls.name?.value
                    }}
                  </b>
                </div>
              </div>
            </div>
          </td>
          <td data-test="xGJwAdfW">
            <div data-test="RrTjZBHq">
              <textarea
                data-test="mBUQPm78"
                (keyup.enter)="saveTaskGroup(getTaskGroupForm(item))"
                [ngrxFormControlState]="groupTask.controls.description"
                class="input input_sm text-light project-textarea"
                rows="2"
                mdScrollToTop
              ></textarea>
            </div>
          </td>
          <td
            data-test="HGc3Tqj5"
            class="text-center"
            [hidden]="currentTab === Tabs.NonBillable"
          >
            <label data-test="V-3gDMT1" class="checkbox">
              <input
                data-test="Rm-Jiq58"
                type="checkbox"
                (input)="toggleGroupTaskBillable(item.value.uuid, groupTask.value.uuid)"
                [checked]="groupTask.value.billable"
              />
              <span data-test="D1vxE7mw" class="checkbox__marker">
                <span data-test="v3cTJf21" class="checkbox__marker-icon">
                  <svg
                    data-test="x_AxetoP"
                    class="icon__icon-check"
                    width="9.07px"
                    height="6.95px"
                  >
                    <use xlink:href="#icon-check"></use>
                  </svg>
                </span>
              </span>
            </label>
          </td>
          <td data-test="nPzuy4Cv" class="text-center" [hidden]="hideBudgetHours">
            <input
              data-test="8zAoODfD"
              [ngrxFormControlState]="groupTask.controls.budgetHours"
              class="input input_sm w-auto text-center"
              mask="0*.00"
              [ngrxValueConverter]="numberConverter"
              [dropSpecialCharacters]="false"
              placeholder="0.00"
              type="text"
              [size]="4"
              (input)="onSetGroupTaskHours(item.id)"
            />
          </td>
          <td
            data-test="gXyZASKy"
            class="text-center text-nowrap"
            *ngIf="
              billingRatePerHour(
                to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
              )
            "
            [class.error]="groupTask.isInvalid"
          >
            <div data-test="cMqrXBc8" class="field-item field-item_offset">
              <div data-test="PvlptYsS" class="field-item__prepend" mdCurrency></div>
              <input
                data-test="KI9fTOe8"
                [ngrxFormControlState]="groupTask.controls.billingRatePerHour"
                [ngrxValueConverter]="numberConverter"
                class="input input_sm text-center"
                placeholder="0.00"
                style="width: 45px"
                [mdNumberInput]
                (input)="calcTaskGroup.emit(item.value.uuid)"
                (blur)="
                  onBillableRateChange(
                    isTaskGroupValidBudgetItem(getTaskGroupForm(item).value)
                      ? item
                      : groupTask
                  )
                "
              />
              <div
                data-test="6Xv_qz04"
                *ngIf="groupTask.isInvalid && !groupTask.value.billingRatePerHour"
                class="field-item__append field-item__append_warning"
              >
                <span
                  data-test="uOM0u6ko"
                  class="icon icon_warning icon_16"
                  [mdTooltip]="'Are you sure you want this rate to be blank?'"
                >
                  <svg
                    data-test="n7pAL1_N"
                    id="icon-warn"
                    viewBox="0 0 24 24"
                    width="100%"
                    height="100%"
                  >
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"></path>
                  </svg>
                </span>
              </div>
            </div>
          </td>
          <td
            data-test="LcBugR0D"
            class="text-center"
            *ngIf="showBudgetFee(to(teamTaskForm.controls.budget.value, 'BudgetTypes'))"
          >
            <span data-test="wDgiWF8l" class="text-light mr-2" mdCurrency></span>
            <input
              data-test="BxIljV4L"
              [ngrxFormControlState]="groupTask.controls.budgetFee"
              [ngrxValueConverter]="numberConverter"
              class="input input_sm w-auto text-center"
              mask="0*.00"
              placeholder="0.00"
              [dropSpecialCharacters]="false"
              type="text"
              [size]="4"
            />
          </td>
          <td
            data-test="_WUzpFKs"
            class="text-right text-nowrap"
            *ngIf="
              billingRatePerHour(
                to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
              ) && !hideBudgetHours
            "
          >
            <span data-test="V_nNlwHX" class="d-inline-block">
              <span data-test="0XW4DWH_" mdCurrency></span>
              {{
                groupTask.value.budgetHours * groupTask.value.billingRatePerHour
                  | companyCurrency
              }}
            </span>
          </td>
        </tr>
      </ng-container>
      <tr
        data-test="RUstdZLm"
        [hidden]="!expandedTaskGroupsEntities[item.value.uuid.toString()]"
        class="row-bg row-type"
      >
        <td data-test="eidZEYiV" class="dd-active">
          <div data-test="-orAso-_" class="d-flex">
            <span data-test="XoEUO5rO" class="items-table__icon">
              <svg
                data-test="tLjPofiU"
                class="icon__icon-path"
                width="8.75px"
                height="11.04px"
              >
                <use xlink:href="#icon-path"></use>
              </svg>
            </span>
            <div data-test="yyEUQ1uz" class="position-relative w-100">
              <div
                data-test="KGoNkW9Z"
                class="form-group__field form-group__field_prepend"
              >
                <md-dropdown
                  data-test="6RvnWfAj"
                  #newGroupTaskDropdown
                  containerClasses="maxw-320"
                  inputClasses="input_sm"
                  placeholder="Enter task name..."
                  labelKey="name"
                  [url]="ListsUrls.Tasks"
                  [limit]="10000"
                  [filterOptionsFn]="filterTasks"
                  groupBy="group"
                  groupByTitleKey="group"
                  searchBy="searchByName"
                  [getOptionsParams]="{
                    status: taskStatuses.ACTIVE,
                    onlySingleTasks: 1,
                    excludeNames: taskNamesByGroup[item.value.uuid.toString()]
                  }"
                  [createOptionPayload]="createTaskPayload(getTaskGroupForm(item).value)"
                  (optionChange)="
                    data.canAddNewTask && createTaskInGroup($event, item.value.uuid)
                  "
                  (find)="onTaskFind($event)"
                  (valueChange)="$event ? newGroupTaskDropdown.clearValue() : null"
                  [canAdd]="canAddTask(newGroupTaskDropdown)"
                  itemName="task"
                  [class.error]="!canAddTask(newGroupTaskDropdown)"
                ></md-dropdown>

                <label
                  data-test="5pTDhd5b"
                  class="form-group__field-prepend link-light"
                  for="subtask-1"
                >
                  <i data-test="DP5uGWpn" class="material-icons md-16">add</i>
                </label>
              </div>
            </div>
          </div>
        </td>
        <td data-test="Ln7BRUrA" colspan="5"></td>
      </tr>
      <tr data-test="CK5GwaDe" class="items-table__spacer"></tr>
    </ng-template>
  </ng-container>
  <ng-container
    *ngFor="let newTask of newTasksForm.controls.tasks.controls; trackBy: trackControl"
  >
    <tr data-test="A77bVFJr">
      <td data-test="E8SVH-3h">
        <div data-test="ui3VdvzD" class="d-flex">
          <div data-test="6RjEKBek" class="position-relative w-100">
            <md-dropdown
              data-test="NDJWrLZ9"
              #newTaskDropdownComponent
              containerClasses="maxw-320"
              inputClasses="input_sm"
              placeholder="Enter task name..."
              searchBy="searchByName"
              labelKey="name"
              groupBy="group"
              groupByTitleKey="group"
              [url]="ListsUrls.Tasks"
              [limit]="10000"
              [filterOptionsFn]="filterTasks"
              [canAdd]="!!data.canAddNewTask && userPermissions.OBJECTS_TASK_CREATE"
              itemName="task"
              [autofocus]="true"
              [createOptionPayload]="createTaskPayload(newTask.value.taskGroup)"
              [class.error]="!data.canAddNewTask"
              [getOptionsParams]="{
                status: taskStatuses.ACTIVE,
                onlySingleTasks: 1,
                excludeNames: taskNames
              }"
              (optionChange)="data.canAddNewTask && addTaskToProject($event)"
              (find)="onTaskFind($event)"
            ></md-dropdown>
          </div>
        </div>
      </td>
      <td data-test="2HPC6HXh">
        <div data-test="eCDiuN41">
          <textarea
            data-test="TTNeFmMS"
            [ngrxFormControlState]="newTask.controls.description"
            class="input input_sm text-light project-textarea"
            rows="2"
            mdScrollToTop
          ></textarea>
        </div>
      </td>
      <td
        data-test="5vLQYjH3"
        class="text-center"
        [hidden]="currentTab === Tabs.NonBillable"
      >
        <label data-test="NjV4g_3Z" class="checkbox">
          <input
            data-test="3luE6_u3"
            [ngrxFormControlState]="newTask.controls.billable"
            type="checkbox"
            checked
          />
          <span data-test="4gxd9VDz" class="checkbox__marker">
            <span data-test="pP5AA5I9" class="checkbox__marker-icon">
              <svg
                data-test="BRM0-3lk"
                class="icon__icon-check"
                width="9.07px"
                height="6.95px"
              >
                <use xlink:href="#icon-check"></use>
              </svg>
            </span>
          </span>
        </label>
      </td>
      <td data-test="GkABJodc" class="text-center" [hidden]="hideBudgetHours">
        <input
          data-test="cZAccT-s"
          [ngrxFormControlState]="newTask.controls.budgetHours"
          class="input input_sm w-auto text-center"
          mask="0*.00"
          placeholder="0.00"
          [ngrxValueConverter]="numberConverter"
          [dropSpecialCharacters]="false"
          type="text"
          [size]="4"
        />
      </td>
      <td
        data-test="Y1Hpe4iG"
        class="text-center text-nowrap"
        *ngIf="
          billingRatePerHour(
            to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
          )
        "
      >
        <div data-test="9mYp94Su" class="field-item field-item_offset">
          <div data-test="8PZaXmVg" class="field-item__prepend" mdCurrency></div>
          <input
            data-test="TMDGGDek"
            [ngrxFormControlState]="newTask.controls.billingRatePerHour"
            [ngrxValueConverter]="numberConverter"
            class="input input_sm text-center"
            mask="0*.00"
            [dropSpecialCharacters]="false"
            placeholder="0.00"
            style="width: 45px"
          />
        </div>
      </td>
      <td
        data-test="sWmO1LrU"
        class="text-center"
        *ngIf="showBudgetFee(to(teamTaskForm.controls.budget.value, 'BudgetTypes'))"
      >
        <span data-test="_0M-7Xlw" class="text-light mr-2" mdCurrency></span>
        <input
          data-test="vsQhvc0s"
          [ngrxFormControlState]="newTask.controls.budgetFee"
          [ngrxValueConverter]="numberConverter"
          class="input input_sm w-auto text-center"
          mask="0*.00"
          placeholder="0.00"
          [dropSpecialCharacters]="false"
          type="text"
          [size]="4"
        />
      </td>
      <td
        data-test="OY26rn77"
        class="text-right text-nowrap"
        *ngIf="
          billingRatePerHour(
            to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
          ) && !hideBudgetHours
        "
      >
        <span data-test="fWZrvQcn" class="d-inline-block">
          <span data-test="U1U4pceW" mdCurrency></span>
          {{
            newTask.value.budgetHours * newTask.value.billingRatePerHour | companyCurrency
          }}
        </span>
      </td>
    </tr>
    <tr data-test="nZJa3o5C" class="items-table__spacer"></tr>
  </ng-container>
  <ng-container
    *ngFor="
      let newTaskGroup of newTasksForm.controls.taskGroups.controls;
      trackBy: trackControl
    "
  >
    <tr data-test="URbT2cZZ">
      <td data-test="w_WOpinu">
        <div data-test="ijTKnll8" class="d-flex">
          <div data-test="kaYB-0pW" class="position-relative w-100">
            <input
              data-test="3174QG0e"
              (keyup.enter)="createTaskGroup(newTaskGroup)"
              [ngrxFormControlState]="
                newTaskGroup.controls.originalTaskGroup.controls.name
              "
              class="input input_sm"
              placeholder="Task group name"
              type="text"
            />
          </div>
        </div>
      </td>
      <td data-test="WKTS0Jc7">
        <div data-test="Ieu7AWnC">
          <textarea
            data-test="vZ_pOhab"
            [ngrxFormControlState]="newTaskGroup.controls.description"
            class="input input_sm text-light project-textarea"
            rows="2"
            mdScrollToTop
          ></textarea>
        </div>
      </td>
      <td
        data-test="80SY6Rkg"
        class="text-center"
        [hidden]="currentTab === Tabs.NonBillable"
      >
        <label data-test="A_m8zaUv" class="checkbox">
          <input
            data-test="DLYzqFjr"
            [ngrxFormControlState]="newTaskGroup.controls.billable"
            type="checkbox"
            checked
          />
          <span data-test="c6nXEFnQ" class="checkbox__marker">
            <span data-test="CRF-HT7j" class="checkbox__marker-icon">
              <svg
                data-test="aubYKdUe"
                class="icon__icon-check"
                width="9.07px"
                height="6.95px"
              >
                <use xlink:href="#icon-check"></use>
              </svg>
            </span>
          </span>
        </label>
      </td>
      <td data-test="JhxtyDYJ" class="text-center" [hidden]="hideBudgetHours">
        <input
          data-test="wTgX5ln9"
          [ngrxFormControlState]="newTaskGroup.controls.budgetHours"
          class="input input_sm w-auto text-center"
          mask="0*.00"
          placeholder="0.00"
          [ngrxValueConverter]="numberConverter"
          [dropSpecialCharacters]="false"
          type="text"
          [size]="4"
        />
      </td>
      <td
        data-test="RG3VNW7F"
        class="text-center text-nowrap"
        *ngIf="
          billingRatePerHour(
            to(teamTaskForm.controls.billingMethod.value, 'BillingMethodsEnum')
          )
        "
      >
        <span data-test="U3c_1d_7" class="text-light mr-2" mdCurrency></span>
        <input
          data-test="0vIvEArb"
          [ngrxFormControlState]="newTaskGroup.controls.billingRatePerHour"
          [ngrxValueConverter]="numberConverter"
          class="input input_sm text-center"
          mask="0*.00"
          [dropSpecialCharacters]="false"
          placeholder="0.00"
          style="width: 45px"
        />
      </td>
      <td
        data-test="wZm2rJ4N"
        class="text-right"
        *ngIf="showBudgetFee(to(teamTaskForm.controls.budget.value, 'BudgetTypes'))"
      >
        <span data-test="VEAPy-f1" class="text-light mr-2" mdCurrency></span>
        <input
          data-test="8XL3Qlrg"
          [ngrxFormControlState]="newTaskGroup.controls.budgetFee"
          [ngrxValueConverter]="numberConverter"
          class="input input_sm w-auto text-center"
          mask="0*.00"
          placeholder="0.00"
          [dropSpecialCharacters]="false"
          type="text"
          [size]="4"
        />
      </td>
    </tr>
    <tr data-test="xZn-1vR0" class="items-table__spacer"></tr>
  </ng-container>
  <tr data-test="UyAvQv34" class="is-hover-state">
    <td data-test="kEsT6f_c" colspan="1000">
      <div data-test="teIYM2P4" class="position-relative">
        <button
          data-test="MKnDGrHg"
          class="button button_primary button_sm"
          #addTaskBtn
          [mdPopover]="addTaskAndGroupDropdown"
        >
          <span data-test="t5NRcXJ-" class="button__icon button__icon_left">
            <i data-test="RGb_JyqI" class="material-icons md-16">add</i>
          </span>
          <span data-test="16csPMcf">Add a new task</span>
          <span data-test="WQk3askh" class="button__icon button__icon_right">
            <i data-test="dWrAFnWj" class="material-icons md-14">keyboard_arrow_down</i>
          </span>
        </button>
        <div
          data-test="CY-La4gr"
          class="dropdown pt-0 dropup"
          id="add-new-task"
          #addTaskAndGroupDropdown
        >
          <div data-test="0DyyIZ5A" class="dropdown__wrap">
            <ul data-test="PTz0oG4Y" class="dropdown__menu" #newTaskDropdown>
              <li data-test="glV0yoSa" class="dropdown__menu-item has-dropdown">
                <md-dropdown
                  data-test="CCZZ_dsQ"
                  dropdownClasses="dropdown_child"
                  [url]="ListsUrls.TaskGroups"
                  [itemName]="'task group'"
                  shape="@project-details-task-group"
                  (valueChange)="addTaskGroupToProject($event)"
                  labelKey="name"
                  [canAdd]="!!(canAddNewTaskGroup$ | async | notNull)"
                  [getOptionsParams]="{ excludeNames: taskGroupNames }"
                  [canCreate]="true"
                  [placeholder]="'Search ...'"
                  [createOptionPayload]="createTaskGroupPayload"
                  [disableCache]="true"
                  [canClearInputValue]="true"
                  (find)="onTaskGroupFind($event)"
                  #cmAddProjectTaskGroupDropdown
                >
                  <ng-template mdTemplate="selected">
                    <li data-test="LZYPe9l9" class="dropdown__menu-item has-dropdown">
                      <a
                        data-test="UTcPQ6tA"
                        class="dropdown__menu-link"
                        style="color: #546e7a"
                      >
                        Task group
                      </a>
                    </li>
                  </ng-template>
                </md-dropdown>
              </li>
              <li
                data-test="8TlHkIh8"
                class="dropdown__menu-item"
                (mousedown)="addNewTask()"
              >
                <a data-test="TZYCWqrq" class="dropdown__menu-link">Single task</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </td>
  </tr>
</ng-container>
